import React from "react";
import { FiAlertCircle, FiPackage } from "react-icons/fi";
import EmptyState from "../common/EmptyState";
import LoadingSkeleton from "../common/LoadingSkeleton";
import classNames from "../common/classNames";
import ProductCard from "./ProductCard";

const ProductGrid = ({
  products = [],
  loading = false,
  error,
  columns = 4,
  view = "grid",
  className,
  cardProps,
  onQuickShop,
  emptyTitle = "No products found",
  emptyDescription = "Try changing your search or filters.",
  emptyActionLabel,
  emptyActionTo,
  onEmptyAction,
  ariaLabel = "Products",
}) => {
  if (loading) {
    return (
      <div className={classNames("product-grid", "product-grid--loading", className)} aria-label="Loading products">
        {Array.from({ length: 8 }, (_, index) => (
          <div className="product-grid__skeleton" key={index}>
            <LoadingSkeleton variant="image" />
            <LoadingSkeleton count={3} variant="line" />
          </div>
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <EmptyState
        className={className}
        icon={FiAlertCircle}
        title="We could not load the products"
        description={typeof error === "string" ? error : "Please refresh the page and try again."}
      />
    );
  }

  if (!products.length) {
    return (
      <EmptyState
        className={className}
        icon={FiPackage}
        title={emptyTitle}
        description={emptyDescription}
        actionLabel={emptyActionLabel}
        actionTo={emptyActionTo}
        onAction={onEmptyAction}
      />
    );
  }

  return (
    <div
      className={classNames(
        "product-grid",
        `product-grid--${view}`,
        `product-grid--${columns}-columns`,
        className
      )}
      role="list"
      aria-label={ariaLabel}
    >
      {products.map((product, index) => (
        <div className="product-grid__item" role="listitem" key={product.id || product.slug}>
          <ProductCard
            product={product}
            onQuickShop={onQuickShop}
            priority={index < columns}
            {...cardProps}
          />
        </div>
      ))}
    </div>
  );
};

export default ProductGrid;
